/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'
import {useEffect} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {SidebarLogo} from '../sidebar/SidebarLogo'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  const {currentUser} = useAuth()

  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div id='fds_app_header' className='app-header'>
      <div
        id='fds_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1 flex-fill',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {/* {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='fds_app_sidebar_mobile_toggle'
              >
                <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className=' svg-icon-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/labor-scheduling/scheduling/overview' className='d-lg-none'>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/fds-logo-small.png?v=2024.4')}
                    className='h-30px'
                  />
                </Link>
              </div>
            </div>
          </>
        )}

        {!config.app.sidebar?.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/labor-scheduling/scheduling/overview'>
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logoqwer'
                  src={toAbsoluteUrl('/media/logos/fds-logo-small-dark.png?v=2024.4')}
                  className='h-20px h-lg-30px app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logoqwer'
                    src={toAbsoluteUrl('/media/logos/fds-logo-small.png?v=2024.4')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logoqwer'
                    src={toAbsoluteUrl('/media/logos/fds-logo-small-dark.png?v=2024.4')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )} */}

        <div
          id='fds_app_header_wrapper'
          className='d-flex justify-content-between align-items-center flex-lg-grow-1 flex-fill'
        >
          <div id='fds_app_header_logo_menu_container' className='d-flex justify-content-start align-items-center flex-even'>
            <SidebarLogo config={config} />
            {config.app.header.default?.content === 'menu' &&
                config.app.header.default.menu?.display && (
                    <div
                      className='app-header-menu app-header-mobile-drawer align-items-stretch order-2'
                      data-fds-drawer='true'
                      data-fds-drawer-name='app-header-menu'
                      data-fds-drawer-activate='{default: true, lg: false}'
                      data-fds-drawer-overlay='true'
                      data-fds-drawer-width='225px'
                      data-fds-drawer-direction='end'
                      data-fds-drawer-toggle='#fds_app_header_menu_toggle'
                      data-fds-swapper='true'
                      data-fds-swapper-mode="{default: 'append', lg: 'prepend'}"
                      data-fds-swapper-parent="{default: '#fds_app_body', lg: '#fds_app_header_logo_menu_container'}"
                    >
                      <Header />
                    </div>
              )}
          </div>
          <div className='d-flex justify-content-center align-items-center flex-even-double'>
            <h2 className='text-gray-900 font-weight-bold'>
              {currentUser?.company?.name} | {currentUser?.company?.brand}
            </h2>
          </div>
          <div className='d-flex justify-content-end align-items-center flex-even'>
            {/* align items left */}
            <Navbar />
          </div>
        </div>
      </div>
    </div>
  )
}
